import http from 'conversations-http/clients/http';
import { buildIndexedViews } from './buildIndexedViews';
export const fetchSpamThreadListService = () => http.get('threadlists/v1/threadlists/hydrated/spam-for-helpdesk').then(({
  hydratedThreadLists
}) => ({
  views: buildIndexedViews({
    customViews: [],
    threadLists: hydratedThreadLists
  })
}));